export default "__VITE_ASSET__BgeGfzbP__"